"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTriggerTypeQuestion = exports.isConditionalCriteriaMet = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/es.array.find.js");
var _lodash = _interopRequireDefault(require("lodash.find"));
var _PctySurvey = require("./PctySurvey.Constants");
var _PctySurvey2 = require("./PctySurvey.Common");
var _questionBuilder = require("@pcty/question-builder");
var isStringList = function isStringList(str) {
  return str ? str.indexOf('[') > -1 && str.indexOf(']') > 0 : false;
};
var getArrayFromStringList = function getArrayFromStringList(strList) {
  var scrubbed = strList.replace(/\[|\]|\s/ig, '');
  return scrubbed.split(',');
};
var isTriggerResponseMet = function isTriggerResponseMet(response, triggerResponse, hasEqualsOperator) {
  var isTriggerMet = false;
  if (!response) return false;

  // check validity of the response with the operator
  if (Array.isArray(triggerResponse) && Array.isArray(response)) {
    // arrays must meet ALL criteria (checkboxes!)
    if (hasEqualsOperator) {
      isTriggerMet = response.filter(function (x) {
        return triggerResponse.includes(x.optionId);
      }).length === triggerResponse.length;
    } else {
      isTriggerMet = response.filter(function (x) {
        return triggerResponse.includes(x.optionId);
      }).length === 0;
    }
  } else {
    response = Array.isArray(response) && response.length === 1 ? response[0].optionId || response : response;
    if (Array.isArray(response)) {
      if (hasEqualsOperator) {
        isTriggerMet = response.filter(function (x) {
          return triggerResponse.includes(x.optionId);
        }).length > 0;
      } else {
        isTriggerMet = response.filter(function (x) {
          return triggerResponse.includes(x.optionId);
        }).length === 0;
      }
    } else {
      if (hasEqualsOperator) {
        isTriggerMet = (response ? response.toString() : '') === triggerResponse;
      } else {
        isTriggerMet = (response ? response.toString() : '') !== triggerResponse;
      }
    }
  }
  return isTriggerMet;
};
var isConditionalCriteriaMet = exports.isConditionalCriteriaMet = function isConditionalCriteriaMet(questions, responses, visibleIfExpression) {
  // return true if we don't have enough info to accurately evaluate
  if (!visibleIfExpression || visibleIfExpression.length <= 0) return true;
  if (!questions || questions.length <= 0 || !responses) return false;
  var scrubbedExpression = visibleIfExpression.replace(/\{|\}/ig, '');
  var jsonExpression = scrubbedExpression;
  // json.parse may fail depending on the expression!
  try {
    jsonExpression = JSON.parse(scrubbedExpression);
  } catch (_unused) {}

  // chop up the expression into clauses
  var rawClauses = jsonExpression.split(/(\sand\s|\sor\s)/);
  if (!rawClauses || rawClauses.length <= 0 || !rawClauses[0] || rawClauses[0].length <= 0) return false;
  var currentConjunction = undefined;
  var validityResults = [];

  // clean up all the clauses
  rawClauses = rawClauses.map(function (clause) {
    return clause.trim().replace(/\\|\"|\'|\s/ig, '');
  });
  rawClauses.map(function (clause, clauseIndex) {
    // check if the clause is a connector and just set it (and do nothing else!)
    if (clause === _PctySurvey.CONDITIONAL_CONJUNCTIONS.AND || clause === _PctySurvey.CONDITIONAL_CONJUNCTIONS.OR) {
      currentConjunction = clause;
      return;
    }

    // evaluate the current statement for validity
    var hasEqualsOperator = clause.indexOf(_PctySurvey.CONDITIONAL_OPERATORS.EQUALS) > 0;
    var parts = hasEqualsOperator ? clause.split(_PctySurvey.CONDITIONAL_OPERATORS.EQUALS) : clause.split(_PctySurvey.CONDITIONAL_OPERATORS.NOT_EQUALS);

    // statement must have ONLY 2 parts (a left side and a right side)
    if (!parts || parts.length !== 2) return;
    var leftPart = parts[0]; // the triggerQuestionId
    var rightPart = isStringList(parts[1]) ? getArrayFromStringList(parts[1]) : parts[1]; // the triggerResponses

    // get the responses for the questionId (left side)
    var question = questions.find(function (x) {
      return x.id === leftPart;
    });
    var response = (0, _PctySurvey2.getResponse)(question, responses);
    var isValid = isTriggerResponseMet(response, rightPart, hasEqualsOperator);

    // EXAMPLE LOGIC OUTPUTS
    // 1=0 -> false
    // 1=1 -> true
    // 1=1 or 1=0 -> true
    // 1=0 or 1=1 -> true
    // 1=1 and 1=0 -> false
    // 1=0 and 1=1 -> false
    // 1=1 or 1=0 or 1=1 and 1=0 -> false
    // 1=0 or 1=1 and 1=0 and 1=1 -> false
    // 1=1 and 1=0 or 1=1 or 1=0 -> false
    // 1=0 and 1=1 and 1=0 or 1=1 -> false

    // 1<>0 -> true
    // 1<>1 -> false
    // 1<>1 or 1<>0 -> true
    // 1<>0 or 1<>1 -> true
    // 1<>1 and 1<>0 -> false
    // 1<>0 and 1<>1 -> false
    // 1<>1 or 1<>0 or 1<>1 and 1<>0 -> true
    // 1<>0 or 1<>1 and 1<>0 and 1<>1 -> false
    // 1<>1 and 1<>0 or 1<>1 or 1<>0 -> false
    // 1<>0 and 1<>1 and 1<>0 or 1<>1 -> false

    if (currentConjunction === _PctySurvey.CONDITIONAL_CONJUNCTIONS.AND) {
      // for AND's, we always care about the result
      validityResults.push(isValid);
    } else if (currentConjunction === _PctySurvey.CONDITIONAL_CONJUNCTIONS.OR) {
      // for OR's, we only care about the result if it's true
      if (isValid) validityResults.push(isValid);
    } else {
      // no connector, so find the next one; if it's an AND, we care about this result! For OR's, only if it's true
      if (rawClauses[clauseIndex + 1]) {
        if (rawClauses[clauseIndex + 1].indexOf(_PctySurvey.CONDITIONAL_CONJUNCTIONS.AND) > -1) {
          // for AND's always save the result
          validityResults.push(isValid);
        } else {
          // for ORs, only save if true
          if (isValid) validityResults.push(isValid);
        }
      } else {
        // no upcoming connector, so save the result
        validityResults.push(isValid);
      }
    }
  });

  // if validityResults has at least 1 trues and 0 falses, the criteria is met
  var criteriaMet = validityResults.length > 0 && validityResults.filter(function (x) {
    return x === true;
  }).length === validityResults.length;
  return criteriaMet;
};
var isTriggerTypeQuestion = exports.isTriggerTypeQuestion = function isTriggerTypeQuestion(typeId) {
  return typeId === _questionBuilder.QUESTION_TYPE.checkbox || typeId === _questionBuilder.QUESTION_TYPE.multipleChoice || typeId === _questionBuilder.QUESTION_TYPE.ratingScale || typeId === _questionBuilder.QUESTION_TYPE.starRating || typeId === _questionBuilder.QUESTION_TYPE.dropdownList;
};